import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import TrendingGrid from './components/TrendingGrid';
import LatestArticles from './components/LatestArticles';
import UserReviews from './components/UserReviews';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOMeta
        title="51黑料网 - 51黑料网今日黑料首页与一区二区 | 最新吃瓜网红爆料每日大赛在线观看"
        description="51黑料网今日黑料首页聚合每日最新网红吃瓜、明星黑料与热门事件爆料，一区二区实时更新在线观看。吃瓜群众首选入口，每日大赛内容不间断，一键直达全网独家黑料资源。"
        keywords="51黑料网,51黑料网今日黑料首页,一区二区,网红吃瓜,每日大赛,在线观看,黑料爆料,吃瓜入口"
        canonicalUrl="https://51heiliaowang.com"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '51黑料网',
            url: 'https://51heiliaowang.com',
            description: '51黑料网今日黑料首页聚合每日最新网红吃瓜、明星黑料与热门事件爆料',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://51heiliaowang.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '51黑料网',
            url: 'https://51heiliaowang.com',
            description: '一站式网红吃瓜、明星黑料、热门事件爆料平台',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '51黑料网今日黑料首页',
            description: '最新吃瓜网红爆料每日大赛在线观看入口',
            url: 'https://51heiliaowang.com',
            isPartOf: { '@type': 'WebSite', name: '51黑料网', url: 'https://51heiliaowang.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '51黑料网是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '51黑料网是一个聚合每日最新网红吃瓜、明星黑料与热门事件爆料的平台，提供一区二区实时更新在线观看，是吃瓜群众的首选入口。',
                },
              },
              {
                '@type': 'Question',
                name: '一区二区有什么区别？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '一区主要聚焦明星娱乐圈的劲爆黑料，涵盖明星八卦、综艺内幕等内容；二区则专注于网红达人圈的独家爆料，深度揭秘行业内幕和网红翻车事件。',
                },
              },
              {
                '@type': 'Question',
                name: '51黑料网的内容多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '51黑料网每日实时更新，每日大赛内容不间断，确保用户第一时间获取最新的吃瓜资讯和黑料爆料。',
                },
              },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://51heiliaowang.com',
              },
            ],
          },
        ]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <TrendingGrid />
        <LatestArticles />
        <UserReviews />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}